import React from 'react'
import { Link } from 'react-router-dom'

const carData = [
    {
        image: 'fv-img1.jpg',
        vehicle_name: '2020 Mercedes-Benz S',
        price: '$64,995',
        mileage: '575',
        vin:'SBM16BEA0SW003214',
    },
    {
        image: 'fv-img2.jpg',
        vehicle_name: '2011 SL550 SPORT',
        price: '$29,000',
        mileage: '30,000',
        vin:'SBM16AEA7SW003690',
    },
    {
        image: 'fv-img3.jpg',
        vehicle_name: '2017 Mercedes-Benz SL',
        price: '$54,000',
        mileage: '11,682',
        vin:'SBM16AEA7PW000568',
    },
    {
        image: 'fv-img4.jpg',
        vehicle_name: '2016 Mercedes-Benz SL',
        price: '$64,995',
        mileage: '575',
        vin:'SBM22GCA5SW003337',
    },
    {
        image: 'fv-img5.jpg',
        vehicle_name: '2021 GLE63-S AMG',
        price: '$94,500',
        mileage: '3,767',
        vin:'SBM16AEA2PW001160',
    },
    {
        image: 'fv-img6.jpg',
        vehicle_name: '2015 Mercedes-Benz S-Class S',
        price: '$43,000',
        mileage: '12,000',
        vin:'SBM16AEA6RW002203',
    },
]
const FeaturedVehicles = ({featuredVehicles, numberFormatter, priceFormatter}) => {
    const isMobile = window.innerWidth <= 768;
    const visibleCars = isMobile ? featuredVehicles.slice(0, 4) : featuredVehicles.slice(0, 6);
    return (
        <>
            <section className='featured-vehicles-wrap wow reveal fadeIn'>
                <div className='container'>
                    <h4 className='lg-title font-3em fw-500 text-start mb-3'>Featured Inventory</h4>
                    <div className='featured-vehicles-block'>
                        <div className='row'>
                            {visibleCars.map((car, index) => (
                                <div className='col-lg-4 col-md-6 col-6 wow reveal fadeIn' key={index}>
                                    <article className="cs-card cs-card--2 fv-box">
                                        <div className="cs-card__img fv-top"
                                            style={{
                                                backgroundImage: `url(${car.images[0]})`,
                                            }}
                                        ></div>
                                        <a 
                                            href={"/vdp?vin=" + car.vin}  className="cs-card_link">
                                            <div className="cs-card__img--hover fv-top"
                                                style={{
                                                    backgroundImage: `url(${car.images[0]})`,
                                                }}></div>
                                        </a>
                                        <div className="fv-bottom">
                                            <div className="fv-title text-theme font-bold">{car.vehicle_name}</div>
                                            <div className="d-flex align-items-center justify-content-between mt-md-1">
                                                <div className="fv-price">{priceFormatter(car.price, true)}</div>
                                                <div className="fv-mileage">{priceFormatter(car.mileage)} mi</div>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='text-center mt-3 wow reveal fadeIn'>
                        <Link to='/inventory' className='black-btn get-started-btn w-330 text-uppercase d-inline-block'>View All</Link>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FeaturedVehicles